import React from "react";

import { useAPICashbackSats } from "hooks/useAPI";

import Item from "..";
import SkeletonItem from "../Skeleton";

const CashbackSatsItem: React.FC = () => {
  const { data } = useAPICashbackSats();

  if (!data) return <SkeletonItem canRenderCashbackSats={true} />;

  return (
    <Item
      key={`DcaSummaryItem-sats`}
      summary={{ earned: data.earned, utilized: data.utilized, available: data.available }}
      isSats
    />
  );
};

export default CashbackSatsItem;
